import { render } from "./consultants-form.vue?vue&type=template&id=622b7760&scoped=true"
import script from "./consultants-form.vue?vue&type=script&lang=js"
export * from "./consultants-form.vue?vue&type=script&lang=js"

import "./consultants-form.vue?vue&type=style&index=0&id=622b7760&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b7760"]])

export default __exports__